module.exports = __webpack_public_path__ + "img/kk.a0c486da.png";